import { Portal, Snackbar } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import React, { useEffect } from 'react';

interface SnackBarProps {
  message: string;
  level: 'info' | 'warning' | 'error' | 'success';
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  }
);

function SnackBar({ message, level }: SnackBarProps) {
  const [open, setOpen] = React.useState(true);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => setOpen(true), [message, level]);

  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={3500}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity={level}
          variant='standard'
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
}

export default SnackBar;
